import { render, staticRenderFns } from "./IlluminateTile.vue?vue&type=template&id=bf5ffd46&"
import script from "./IlluminateTile.vue?vue&type=script&lang=js&"
export * from "./IlluminateTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports